// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imgPreview {
  width: 8em;
  height: 8em;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.myForm {
  gap: 0.5em;
  justify-content: center;
}
.myForm .flxRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.5em 0;
}
.myForm .flxRow label {
  min-width: 8.5em;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/app/helpdeskreply.component.ts"],"names":[],"mappings":"AAAA;EAAa,UAAA;EAAY,WAAA;EAAa,wBAAA;EAA0B,4BAAA;EAA8B,2BAAA;AAM9F;;AAN2H;EAAU,UAAA;EAAY,uBAAA;AAWjJ;AAX0K;EAAU,aAAA;EAAgB,mBAAA;EAAqB,mBAAA;EAAqB,gBAAA;AAiB9O;AAjBgQ;EAAQ,gBAAA;EAAkB,gBAAA;AAqB1R","sourcesContent":[".imgPreview {width: 8em; height: 8em; background-size: contain; background-repeat: no-repeat; background-position: center} .myForm { gap: 0.5em; justify-content: center; .flxRow { display: flex;  flex-direction: row; align-items: center; padding: 0.5em 0; label { min-width: 8.5em; text-align: left; }} } "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
